import React, { FunctionComponent, MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { Alert as AlertModel, AlertSeverity, removeAlertThunk } from '@spike/notifications-action';
import clsx from 'clsx';
import styles from './Alert.module.scss';

interface AlertProps {
    alert: AlertModel;
    className?: string;
}

export const Alert: FunctionComponent<AlertProps> = props => {
    const dispatch = useDispatch();

    const getIcon = (alert: AlertModel) => {
        let icon = faCheckCircle;

        if (alert.severity === AlertSeverity.WARNING) {
            icon = faExclamationTriangle;
        } else if (alert.severity === AlertSeverity.ERROR) {
            icon = faTimesCircle;
        }

        return (
            <FontAwesomeIcon
                className={styles.icon}
                icon={icon}
                size="2x"
            />
        );
    };

    const clickAlertHandler = (event: MouseEvent, alertKey: string) => {
        event.stopPropagation();
        dispatch(removeAlertThunk(alertKey));
    };

    return (
        <div
            key={props.alert.key}
            className={clsx(
                styles.alert,
                {
                    [styles.alertSuccess]: props.alert.severity === AlertSeverity.SUCCESS,
                    [styles.alertWarning]: props.alert.severity === AlertSeverity.WARNING,
                    [styles.alertError]: props.alert.severity === AlertSeverity.ERROR
                },
                props.className
            )}
            onClick={event => clickAlertHandler(event, props.alert.key)}
        >
            <div className={styles.alertIcon}>{getIcon(props.alert)}</div>
            <div className={styles.alertText}>
                <span className={styles.text}>{props.alert.message}</span>
            </div>
        </div>
    );
};

export default Alert;
